// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomEmployeeProfessionalsRelationshipsItem from './data'

export default function DataVaxiomEmployeeProfessionalsRelationshipsItemFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem">
      <DataVaxiomEmployeeProfessionalsRelationshipsItem {...props}>
        {children}
      </DataVaxiomEmployeeProfessionalsRelationshipsItem>
    </Flow>
  )
}
